import React, { Component } from 'react'
import { FaArrowLeft, FaArrowRight, FaEllipsisH, FaEye, FaSearch, FaFilter, FaFileContract } from 'react-icons/fa';
import { Table, Tag, Menu, Dropdown, Button, message, Input } from 'antd'
import { withRouter } from 'react-router-dom';
import FilterModal from '../../components/FilterModal/FilterModal';
import { connect } from 'react-redux';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
import moment from "moment";
import { DeleteObligation, GetCustomerAllObligations, GetCustomerObligations, GetObligations } from '../../network/request.network';
const { Search } = Input;
const suffix = (
  <FaSearch
    style={{
      fontSize: 20,
      color: '#939598',
    }}
  />
);

class Bonds extends Component {

    state = {
      tableLoading : false,
      showFilter : false,
      showDltModal : false,
      BondInfo : false,
      bondList : [],
      bondASAfterSearch : [],
    }
    
    componentDidMount() {
      this.handelGetCustomerObligations();
    }

    handelGetCustomerObligations = () => {
      this.setState({tableLoading : true})
      let params ='';
      GetCustomerAllObligations(
        params, 
        (res) => { 
          this.setState({tableLoading : false, bondList : res.data?.model, bondASAfterSearch : res.data?.model})
        }, 
        (err) => {
          this.setState({tableLoading : false})
        })
    }

    itemRender = (current, type, originalElement) =>  {
        if (type === 'prev') {
          return <a className="prev-page-btn pagin-page-btn"><FaArrowRight />  الصفحة السابقة </a>;
        } 
        if (type === 'next') { 
          return <a className="next-page-btn pagin-page-btn">الصفحة التاليه  <FaArrowLeft /> </a>;
        }
        return originalElement;
    }

    handelShowFilter = () => {
      this.setState({showFilter : true})
    }

    handelCloseFilter = () => {
      this.setState({showFilter : false})
    }

    closeDltModal = () => { 
      this.setState({showDltModal : false})
    }

    handeldeleteBond = () => {
      this.setState({tableLoading : true})
      const {BondInfo} = this.state;
      DeleteObligation(
        BondInfo?.Id, 
        (res) => {
          message.success("تم حذف المستند بنجاح");
          this.setState({bondList : this.state.bondList.filter(ele => ele.Id !== BondInfo?.Id), tableLoading : false})
          this.setState({bondASAfterSearch : this.state.bondASAfterSearch.filter(ele => ele.Id !== BondInfo?.Id), tableLoading : false})
        },
        (error) => {
          this.setState({tableLoading : false})
          //console.log(error);
        }
      );
    };

    handleSearchBond = (val) => {
      let value = val.target.value;
      // console.log(value)
      if(isNaN(value)){
        let bondAS = this.state.bondList.filter(team => {
          //console.log(team) 
          if( team?.CustomerFullName?.includes(value))
            return team;
        });
        //console.log(bondAS)
        this.setState({bondASAfterSearch: bondAS});
      }else{
        let bondAS = this.state.bondList.filter(team => { 
          //console.log(team) 
          if((""+team?.FinancingRequestId)?.includes(value) || team?.CustomerPhoneNumber?.includes(value))
            return team;
        });
        // console.log(bondAS)
        this.setState({bondASAfterSearch: bondAS});
      }
    }

    render() {
        const {tableLoading, showFilter, showDltModal, bondList, bondASAfterSearch} = this.state;
        
        return (
            <div className="quality-wrapper order-tab-holder">
              {showDltModal && <DeleteModal delete={this.handeldeleteBond} name="السند" closeDltModal={this.closeDltModal} /> }

                <div className="container"> 
                {showFilter && <FilterModal handelCloseFilter={this.handelCloseFilter} />}
                {/* <TabHeader showType="bonds" handelShowFilter={this.handelShowFilter} title={"السندات"} />  */}
                
                <div className="order-tabs-header">
                  <div className="order-header-content">
                      <h1>السندات</h1>
                      <div className="order-header-search">
                          <Search
                              placeholder="البحث برقم الطلب "
                              // enterButton="Search"
                              size="large"
                              prefix={suffix}
                              // onSearch={onSearch}
                              onChange ={this.handleSearchBond}
                          />
                          <div className="header-search-action">
                          <Button type="primary" onClick={this.props.handelShowFilter} icon={<FaFilter />}>
                                تصفيه
                            </Button>
                            {/* <Button type="primary" className="blue-btn" icon={<FaFileContract />} onClick={() => {this.props.history.push("/search-bond")}}>
                                سند جديد
                            </Button> */}
                          </div>
                      </div>
                  </div>
              </div>


                <Table
                    loading={tableLoading}  
                    editable
                    pagination={{ simple : true, itemRender : this.itemRender }}  
                    onRow={(record, rowIndex) => {
                        return {
                        onClick: e => {
                          e.preventDefault();
                          e.stopPropagation(); 
                          //console.log('ssssssssssssssssssssssssss')
                        }  
                        }; 
                    }}
                    rowKey = "Id" 
                    className="table-roles-wrapper app-table-wrapper table-hover-wrapper order-table"
                    columns={[
                        {
                            title: `رقم السند`,
                            dataIndex: 'Id',
                        }, 
                        {
                            title: `اسم العميل`, 
                            dataIndex: 'CustomerFullName',
                        },
                        {
                            title: `رقم الطلب`,
                            dataIndex: 'FinancingRequestId',
                        },
                        {
                          title: `رقم الجوال`,
                          dataIndex: 'phone',
                          render: (text, record) => (
                            <div className="phone-style">
                              {record?.CustomerPhoneKey+record?.CustomerPhoneNumber}
                            </div>
                          ),
                        },
                        {
                            title: `سبب السند`,
                            dataIndex: 'ObligationReason',
                            render: (text, record) => (
                              <div>
                                {record?.ObligationReason?.NameLT}
                              </div>
                            ),
                        },
                        {
                            title: `قيمه السند`,
                            dataIndex: 'Amount',
                        },
                        {
                            title: `تاريخ الإنشاء`, 
                            render: (text, record) => (
                              <div className="phone-style">
                                {moment.utc(record?.CreationDate).local().format("YYYY-MM-DD HH:mm:ss")}
                              </div>
                            ),
                        },
                        {
                            title: 'حاله نافذ',
                            key: 'action',
                            render: (text, record) => (
                              <Tag className="contact-tag" color="cyan">
                                {record?.ObligationStatus?.NameLT}
                            </Tag>
                            ),
                          },
                          {
                            title: 'اجراءت',  
                            key: 'action',
                            render: (text, record) => (
                              <Dropdown overlayClassName="action-dropdown-holder" 
                                trigger={['click']} onClick={(e)=> {
                                  e.preventDefault();
                                  e.stopPropagation();
                                } }  overlay={    
                                <Menu>
                                  <Menu.Item className="show-item" icon={<FaEye />} 
                                  onClick={() => this.props.history.push({
                                      pathname: `/client`,
                                      state: { orderId: record?.FinancingRequest?.Id }
                                  })}
                                  // onClick={() => this.props.history.push("/client/7")}
                                  >
                                    <p>عرض</p>
                                  </Menu.Item> 
                                  {/* <Menu.Item  icon={<FaDownload />}>
                                    <p>تحميل</p>
                                  </Menu.Item> */}
                                  {/* <Menu.Item className="remove-item" icon={<FaTrashAlt />} 
                                    onClick={(e) => {
                                    // e.preventDefault(); 
                                    // e.stopPropagation();
                                      console.log('qqqqqqqqqqqqqqq')
                                    this.setState({showDltModal : true, BondInfo: record})
                                    }}>
                                    <p>حذف </p>
                                  </Menu.Item> */}
                                </Menu>} placement="bottomLeft">
                                <div className="dropdown-icon-holder">
                                    <FaEllipsisH  />
                                </div>
                              </Dropdown>
                            ),
                          },
                    ]}
                    dataSource={bondASAfterSearch}
                />
                </div>  
            </div>
        )
    }
}
const BondsWithRouter = withRouter(Bonds);
const mapStateToProps = (state) => ({
  currentUser : state.user.currentUser,
}) 
export default connect(mapStateToProps)(BondsWithRouter);  
